<div data-testid="zone-tile">
    <div class="zone__top border-zone">
        <floating-subtitle class="zone__name zone__name--tile font-22"
            [text]="subtitle(tile.params.txtId)">
        </floating-subtitle>
    </div>

    <div class="zone__status cursor-pointer">
        <div class="gradient-zone zone__status-background" data-testid="animation"
             [ngClass]="{ 'zone__status--animated': tile.params.workingStatus }">
        </div>
    </div>

    <div class="zone__content">
        <div class="zone__content-icon">
            <icon [iconId]="tile.params.iconId"
                [attr.data-testid]="'tile-icon-id-' + tile.params.iconId"
                [iconSize]="views.isMobileView() ? 50 : 62">
            </icon>
        </div>
        <floating-subtitle class="zone__current-temp zone__current-temp--relay font-38"
            data-testid="tile-value"
            [text]="subtitle(1447)"
            *ngIf="tile.params.workingStatus">
        </floating-subtitle>
        <floating-subtitle class="zone__current-temp zone__current-temp--relay font-38"
            data-testid="tile-value"
            [text]="subtitle(924)"
            *ngIf="!tile.params.workingStatus">
        </floating-subtitle>
    </div>
    <div class="zone__footer zone__footer--temp bg-style"></div>
    <div class="zone__to-menu cursor-pointer"
         *ngIf="tile.menuId > 0"
         (click)="setTemplate(tile)">
    </div>
</div>
